import type { InboxNotification, InboxPage, InboxRepository, PendingSummary } from '@/domain/inbox/Inbox'

export const BELL_NOTIFICATIONS_SHOWN = 5

export interface BellData {
  pending: PromiseSettledResult<PendingSummary>
  notifications: PromiseSettledResult<InboxPage>
  unread: PromiseSettledResult<InboxPage>
}

export async function loadBell(inbox: InboxRepository): Promise<BellData> {
  const [pending, notifications, unread] = await Promise.allSettled([
    inbox.pending(0),
    inbox.notifications(BELL_NOTIFICATIONS_SHOWN),
    inbox.notifications(BELL_NOTIFICATIONS_SHOWN, true),
  ])
  return { pending, notifications, unread }
}

export function bellNotices(
  unread: readonly InboxNotification[],
  latest: readonly InboxNotification[],
  limit = BELL_NOTIFICATIONS_SHOWN,
): InboxNotification[] {
  const unreadIds = new Set(unread.map((n) => n.id))
  return [...unread, ...latest.filter((n) => !unreadIds.has(n.id))].slice(0, limit)
}
